export const AVIF = 'image/avif'
export const WEBP = 'image/webp'
export const PNG = 'image/png'
export const JPEG = 'image/jpeg'
export const JXL = 'image/jxl'
export const JP2 = 'image/jp2'
export const HEIC = 'image/heic'
export const GIF = 'image/gif'
export const SVG = 'image/svg+xml'
export const ICO = 'image/x-icon'
export const ICNS = 'image/x-icns'
export const TIFF = 'image/tiff'
export const BMP = 'image/bmp'
export const PDF = 'application/pdf'
